// @flow
import {Space, Table, message, Switch, Tag, Button} from 'antd';
import type { ColumnsType } from 'antd/es/table';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {EditOutlined, SearchOutlined} from '@ant-design/icons';
import {requestDeviceList} from "../../../axios/http";
import {ChildDevice} from "../child/device";
interface Props {
  username: string;
}
export const Device = (props: Props) => {
  let { username } = props;
  let [data, setData] = useState<DataType[]>([]);
  let [id, setId] = useState<number>(0);
  let [show, setShow] = useState<boolean>(false);
  let navigate = useNavigate();
  interface DataType {
    "id": number,
    "eui": string,
    "name": string,
    "description": string,
    "creator": number,
    "enable": boolean,
    "online": boolean,
    "script": null | string,
    "device_type": string,
    "active_time": null | number,
    "create_time": number
  }

  async function getDeviceList(){
   const result = await requestDeviceList()
    setData(result.data.devices)
  }

  // @ts-ignore
  useEffect(() => {
    getDeviceList()
  }, []);

  const columns: ColumnsType<DataType> = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: text => <a>{text}</a>,
    },
    {
      title: 'Eui',
      dataIndex: 'eui',
      key: 'eui',
      render: text => <a>{text}</a>,
    },
    {
      title: 'Enable',
      key: 'enable',
      dataIndex: 'enable',
      render: text => <div>
                        {text ? <Tag color={'green'} key={text}>
                          enable
                        </Tag>:<Tag color={'red'} key={text}>
                          Not enabled
                        </Tag>}
                    </div>,
    },
    {
      title: 'Enable',
      key: 'online',
      dataIndex: 'online',
      render: text => <div>
        {text ? <Tag color={'green'} key={text}>
          online
        </Tag>:<Tag color={'red'} key={text}>
          Disconnection
        </Tag>}
      </div>,
    },
    {
      title: 'Device Type',
      key: 'device_type',
      dataIndex: 'device_type',
      render: text => <div>{text === 'LoRaGate' ? <Tag color={'green'} key={text}>
        {text}
      </Tag>:<Tag color={'geekblue'} key={text}>
        {text}
      </Tag>}</div>,
    },
    {
      title: 'Active Time',
      dataIndex: 'active_time',
      key: 'active_time',
      render: text => <a>{text&&moment(text).format('YYYY-MM-DD HH:mm:ss')}</a>,
    },
    {
      title: 'Create Time',
      dataIndex: 'create_time',
      key: 'create_time',
      render: text => <a>{text&&moment(text).format('YYYY-MM-DD HH:mm:ss')}</a>,
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      render: text => <a>{text}</a>,
    },
    {
      title: 'Edit Details',
      dataIndex: 'id',
      key: 'id',
      render: text => <Button type="primary" icon={<SearchOutlined />} size={'small'} onClick={()=>{
        setId(text)
        setShow(true)
      }}>
        Show
      </Button>,
    },
  ];

  useEffect(() => {


  }, []);
  return (
    <div style={{ height: '100%' }}>
      <Table columns={columns} dataSource={data} size="small" />
      {show && <ChildDevice id={id} key={id}/>}
    </div>
  );
};
